import { CompanyType } from '@utilities-one/api-sdk';

export const companyTypeNames = {
  [CompanyType.inhouse]: 'Inhouse',
  [CompanyType.externalVendor]: 'External Vendor',
  [CompanyType.employee1099]: '1099',
};
